import API from '../../services/client'


export default async ()=>{
    const lives =  await API.CatalogueManager.lives.findMany()
    for(let live in lives.results){
        lives.results[live].images = await API.CatalogueImage.images.findMany({ session_uuid : lives.results[live].session_uuid })
    }
    return lives
}